<template>
  <div class="grid grid--even grid--multiline">
    <div
      v-for="(choice, i) in localField.choices"
      :key="i"
      class="grid__item relative-parent"
      :class="gridItemClass"
    >
      <input
        :id="`field-radio-${localField.id || localField.name}-${choice[0]}`"
        type="radio"
        :value="choice[0]"
        :name="localField.name"
        class="grid-radio-input"
        :class="fieldClass"
        :required="localField.required"
        :checked="choice[0] === value"
        :disabled="localField.disabledChoices?.includes(choice[0])"
        @change="$emit('input', choice[0])"
      />
      <label
        :for="`field-radio-${localField.id || localField.name}-${choice[0]}`"
        class="grid-radio box box--default"
        :class="labelClass"
      >
        <div class="grid-radio-body">
          <slot :choice="choice"></slot>
        </div>
      </label>
    </div>
  </div>
</template>

<script>
import { computed, inject } from 'vue';
import { formGroupKey } from '@/components/forms/FormGroup.vue';

export default {
  props: {
    fieldClass: {
      type: String,
      default: null,
    },
    labelClass: {
      type: String,
      default: 'box--small',
    },
    gridItemClass: {
      type: [Object, Array, String],
      default: null,
    },
    value: {
      required: false,
      type: [Boolean, String, Object],
      default: null,
    },
    field: {
      type: Object,
      required: true,
    },
  },

  setup(props) {
    const group = inject(formGroupKey, { field: null, id: null });
    const localField = computed(() => {
      return props.field || group.field;
    });

    return {
      localField,
    };
  },
};
</script>

<style lang="scss" scoped>
.grid-radio {
  display: block;

  position: relative;

  font-weight: 400;

  border: 2px solid transparent;

  .grid-radio-input:checked + & {
    border-color: $brand-color;

    .grid-radio-body::before {
      transform: scale(1);
      transition: transform 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    }
  }

  .grid-radio-input:disabled + & {
    opacity: 0.5;
    pointer-events: none;
  }

  &:hover,
  .grid-radio-input:focus + & {
    border-color: $brand-alt-color;
  }
}

.grid-radio-body {
  position: relative;

  &::before {
    content: '';
    display: block;
    width: 32px;
    height: 32px;

    position: absolute;
    top: 0;
    right: 0;

    border-radius: 50%;
    background: $brand-color
      url('data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2024%2024%22%20fill%3D%22%23fff%22%3E%3Cpath%20d%3D%22M3.05%2C12.53a2%2C2%2C0%2C0%2C1%2C3.41-1.41L9.05%2C13.7l8.59-8.58a2%2C2%2C0%2C0%2C1%2C2.82%2C2.82L9.05%2C19.36%2C3.64%2C13.94A2%2C2%2C0%2C0%2C1%2C3.05%2C12.53Z%22%2F%3E%3C%2Fsvg%3E')
      no-repeat center;
    background-size: 18px 18px;
    transform: scale(0);
    transition: transform 0.3s ease-in;
  }
}

.grid-radio-input {
  position: absolute;
  top: $spacing-unit-default;
  right: $spacing-unit-default;
  opacity: 0;
}
</style>
